module.exports = __webpack_public_path__ + "img/s.815a1bc6.webp";